// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/screens/EcoToken/index.css
// module id = 2608
// module chunks = 0